<!--
 * @Author: Wangchaoke
 * @Date: 2020-02-26 10:12:32
 * @LastEditTime: 2021-05-10 15:07:15
 * @LastEditors: wenjing
 * @Description: 生长记录页面
 * @FilePath: /xm-mini-program/Users/wj/checkout/feihe/xingmahui_front/src/components/contents/grow/growTablev1.0.vue
 -->
<template>
  <div id="app">
    <div class="text" @click="tolink">
      什么是成长发育曲线
      <img src="../../../assets/images/grow/rule2.png" alt />
    </div>
    <div v-if="noBabyBir">
      <!-- 孕期 -->
      <span class="unit" v-if="heightShow">身高(mm)</span>
      <span class="unit" v-if="weightShow">体重(g)</span>
      <span class="unit" v-if="headShow">头围(cm)</span>
      <iframe :src="hostName==localhostName? hostName+'/grow/noBabyHeight.html?sex=o&num='+this.babyNum+'&type=1&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth : localhostName+'/grow/noBabyHeight.html?sex=o&num='+this.babyNum+'&type=1&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth" style="border:none;" v-if="heightShow"></iframe>
      <iframe :src="hostName==localhostName? hostName+'/grow/noBabyWeight.html?sex=o&num='+this.babyNum+'&type=1&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth : localhostName+'/grow/noBabyWeight.html?sex=o&num='+this.babyNum+'&type=1&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth" style="border:none;" v-if="weightShow"></iframe>
      <iframe :src="hostName==localhostName? hostName+'/grow/noBabyHead.html?sex=o&num='+this.babyNum+'&type=1&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth : localhostName+'/grow/noBabyHead.html?sex=o&num='+this.babyNum+'&type=1&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth" style="border:none;" v-if="headShow"></iframe>
    </div>
    <div v-else>
      <!-- 宝宝出生后 -->
      <span class="unit" v-if="heightShow">身高(cm)</span>
      <span class="unit" v-if="weightShow">体重(kg)</span>
      <span class="unit" v-if="headShow">头围(cm)</span>
      <iframe :src="hostName==localhostName? hostName+'/grow/babyHeight.html?sex='+babySex+'&num='+this.babyNum+'&type=2&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth : localhostName+'/grow/babyHeight.html?sex='+babySex+'&num='+this.babyNum+'&type=2&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth" style="border:none;" v-if="heightShow"></iframe>
      <iframe :src="hostName==localhostName? hostName+'/grow/babyWeight.html?sex='+babySex+'&num='+this.babyNum+'&type=2&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth : localhostName+'/grow/babyWeight.html?sex='+babySex+'&num='+this.babyNum+'&type=2&bir='+this.babyBir+'&sourceFrom='+sourceFrom+'&growth='+growth" style="border:none;" v-if="weightShow"></iframe>
      <iframe :src="hostName==localhostName? hostName+'/grow/babyHead.html?sex='+babySex+'&num='+this.babyNum+'&type=2&bir='+this.babyBir+'&headShow='+this.babyHeadShow+'&sourceFrom='+sourceFrom+'&growth='+growth : localhostName+'/grow/babyHead.html?sex='+babySex+'&num='+this.babyNum+'&type=2&bir='+this.babyBir+'&headShow='+this.babyHeadShow+'&sourceFrom='+sourceFrom+'&growth='+growth" style="border:none;" v-if="headShow"></iframe>
    </div>
    <div class="textTitle" v-if="txtShow" @click="tolink">
      什么是成长发育曲线
      <img src="../../../assets/images/grow/rule2.png" alt />
    </div>
  </div>
</template>

<style lang="less" scoped>
#app {
  // position: relative;
  // top: 65px;
  margin-top: 5px;
  background: #fff;
  .unit {
    font-size: 11px;
    transform: scale(0.6);
    color: rgba(102, 102, 102, 1);
    margin-left: 15px;
  }
  .text {
    color: #88a6c9;
    // width: 140px;
    display: table;
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 15px;
    // background-image: url('../../assets/images/grow/rule.png');
    // background-repeat: no-repeat;
    // background-size: 12px 12px;
    // background-position: 112px 2px;
    img {
      width: 12px;
      height: 12px;
      padding-left: 2px;
      position: relative;
      top: 1px;
    }
  }
  .textTitle {
    display: table;
    margin: 0 auto;
    position: relative;
    top: -4px;
    z-index: 999;
    color: #88a6c9;
    // width: 140px;
    // background-image: url('../../assets/images/grow/rule.png');
    // background-repeat: no-repeat;
    // background-size: 12px 12px;
    // background-position: 112px 2px;
    img {
      width: 12px;
      height: 12px;
      padding-left: 2px;
      position: relative;
      top: 2px;
    }
  }
  iframe {
    width: 100%;
    height: 365px;
  }
}
</style>


<script>
// 引入api接口
import API from "@/utils/axiosApi/growApi";
import { getCookie } from '@/assets/js/common.js'
export default {
  name: "app",
  data () {
    return {
      xAxisData: undefined,
      hostName: this.$http.hostName,
      localhostName: "",
      babyNum: "",
      txtShows: true,
      sourceFrom: this.$route.query.sourceFrom,
      growth: this.$route.query.growth
    };
  },
  created () { },
  mounted () {
    if (this.$route.query.num) {
      this.babyNum = this.$route.query.num;
    } else {
      this.babyNum = this.babyInfo.num
    }

    // if(this.getCookie('randomNum')=='1'){
    //   this.localhostName = window.location.protocol + "//" + window.location.host+'/b';
    // }else{
    //   this.localhostName = window.location.protocol + "//" + window.location.host;
    // }
    this.localhostName = window.location.protocol + "//" + window.location.host;
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h == 1024) {
      $("iframe").css("height", "630px");
    } else if (h == 1366) {
      $("iframe").css("height", "815px");
    }
    if (this.txtShow) {
      $('.text').hide()
    }
  },
  props: {
    heightShow: {
      default: false,
      type: Boolean
    },
    weightShow: {
      default: false,
      type: Boolean
    },
    headShow: {
      default: false,
      type: Boolean
    },
    babySex: {
      default: "",
      type: String
    },
    babyBir: {
      default: "",
      type: String
    },
    noBabyBir: {
      default: false,
      type: Boolean
    },
    babyHeadShow: {
      default: false,
      type: Boolean
    },
    txtShow: {
      default: false,
      type: Boolean
    },
    babyInfo: {}
  },
  methods: {
    getCookie,
    tolink: function () {
      sensors.track('GrowthCurveInfoClick')
      this.$router.push({ path: "/growthRecord/growthRule" });
    }
  }
};
</script>
